import {
  IVisitorsDashboardTranslations,
  IVisitorSidebar,
  IVisitorSettingsTranslations,
  IVisitorExhibitorTranslations,
  IVisitorOnboardingTranslations,
  IVisitorNetworkingTranslations,
  IVisitorSessions,
  IVisitorProfile,
  IVisitorProducts,
} from '@/translations/default/visitors';

const dashboard: Partial<IVisitorsDashboardTranslations> = {
  featured_products: 'Produtos destacados',
};

const sidebar: Partial<IVisitorSidebar> = {
  // Leave empty until needed
};

const settings: Partial<IVisitorSettingsTranslations> = {
  // Leave empty until needed
};

const exhibitors: Partial<IVisitorExhibitorTranslations> = {
  subtitle: 'Ver expositores e consultar produtos',
  exhibitor_information: 'Informação de marca',
  noExhibitors: 'Sem marcas para mostrar.',
  contact_success: 'Partilha de contactos efetuada com sucesso!',
  interacted_exhibitors: 'Expositores com que interagi',
  not_interacted_exhibitors: 'Expositores com que não interagi',
  filter_exhibitors: 'Filtrar expositores',
  contact_request: 'Partilhar contactos',
  company_info: 'Informação da marca',
  job_offers: 'Produtos',
  apply_to_job_offer: 'Registar interesse',
  job_offer_info: 'Informação do produto',
  cover_letter: 'Pedido de informação',
  cover_letter_text: 'Deixe uma mensagem à marca',
  your_info_will_be_shared: 'A sua informação de registo será partilhada com a marca',
  submit_my_application: 'Submeter',
  successfully_submited: 'Efetuado com sucesso',
  already_applied: 'Já efetuou este registo de interesse',
  schedule_interview: 'Reserve o seu lugar',
  select_time_slot: 'Selecione um horário para participar',
};

const onboarding: DeepPartial<IVisitorOnboardingTranslations> = {
  // Leave empty until needed
};

const networking: Partial<IVisitorNetworkingTranslations> = {
  // Leave empty until needed
};

const sessions: Partial<IVisitorSessions> = {
  // Leave empty until needed
};

const profile: Partial<IVisitorProfile> = {
  // Leave empty until needed
};

const products: IVisitorProducts = {
  title: 'Produtos',
  subtitle: 'Procurar e interagir com produtos',
  products_same_brand: 'Produtos do mesmo expositor',
  select_category: 'Selecione uma categoria',
};

export default {
  dashboard,
  settings,
  exhibitors,
  onboarding,
  sidebar,
  networking,
  sessions,
  profile,
  products,
};
